/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';

export const LocaleContext = React.createContext();

export function LocaleProvider({ children }) {
  const [configuration, setConfiguration] = useState({
    temperature: {
      celsius: true,
    },
  });

  useEffect(() => {
    const data = localStorage.getItem('locale');
    if (data) setConfiguration(JSON.parse(data));
  }, []);

  const updateConfiguration = config => {
    localStorage.setItem('locale', JSON.stringify(config));
    setConfiguration(config);
  };

  return (
    <LocaleContext.Provider value={{ configuration, updateConfiguration }}>
      {children}
    </LocaleContext.Provider>
  );
}

export const useLocale = () => useContext(LocaleContext);
